import { flow, types } from "mobx-state-tree";
import { ErrorModel } from "../../components/common/error";
import { IInput } from "../../utils/common-interface";
import customtypes from "../../utils/mobx-types-helper";
import { ShareHolderModel } from "../org/OrganizeModel";
import { PaginationModel } from "../share/PagingModel";
import { ProposalModel } from "./ProposalModel";
import proposalAPI from "./ProposalService";

export const ProposalPlanListModel = types
  .model("ProposalPlanListModel", {
    planStatus: customtypes.optional(types.string, ""),
    planRelease: customtypes.optional(types.string, ""),
    planYearFilter: types.maybeNull(types.number),
    list: customtypes.optional(types.array(ProposalModel), []),
    paging: customtypes.optional(PaginationModel, {}),
    organizationID: types.maybeNull(types.number),
    organization: types.optional(ShareHolderModel, {}), //  ShareHolderModel เพราะต้องใช้กับ OrganizationDropdown
    error: customtypes.optional(ErrorModel, {}),
    loading: types.optional(types.boolean, false),
  })
  .views((self: any) => ({
    //
  }))
  .actions((self: any) => ({
    getProposalPlanList: flow(function*() {
      try {
        self.loading = true;
        const result = yield proposalAPI.getProposalPlanList({
          organizationID: self.organizationID,
          startYear: self.planYearFilter,
          planRelease: self.planRelease,
          planStatus: self.planStatus,
          paging: self.paging,
        });
        self.list = result.data;
        self.setPagination(result);
      } catch (e) {
        self.error.tigger = true;
        self.error.code = e.code;
        self.error.title = e.name;
        self.error.message = e.message;
        self.error.technicalStack = e.technicalStack;
        throw e;
      } finally {
        self.loading = false;
      }
    }),
    removeProposalPlan: flow(function*(planID: number) {
      try {
        self.loading = true;
        const result = yield proposalAPI.removeProposalPlan(planID);
        // console.log("removeProposalPlan", result);
        // self.setAllField(result.data);
      } catch (e) {
        self.error.tigger = true;
        self.error.code = e.code;
        self.error.title = e.name;
        self.error.message = e.message;
        self.error.technicalStack = e.technicalStack;
        throw e;
      } finally {
        self.loading = false;
      }
    }),
    setField: ({ fieldname, value }: IInput) => {
      self[fieldname] = value;
    },
    onSelectedFilter: (value: any) => {
      self.setDefaultPagination();
      self.planStatus = value;
      self.getProposalPlanList();
    },
    setPagination: (result: any) => {
      self.paging.pageSize = result.pageSize;
      self.paging.pageNo = result.pageNo;
      self.paging.totalRow = result.totalRow;
    },
    onSelectedPage: (pageNo: number) => {
      self.paging.pageNo = pageNo;
      self.getProposalPlanList();
    },
    setDefaultPagination: () => {
      self.paging.pageNo = 1;
    },
    onClearFilter: () => {
      self.organization = {};
      self.organizationID = undefined;
      self.planStatus = "";
      self.planRelease = "";
      self.list = [];
      self.planYearFilter = null;
    },
    resetAll: () => {
      self.list = [];
      self.paging = {};
    },
  }));

export type IProposalPlanListModel = typeof ProposalPlanListModel.Type;
